export default function ArrowRightIcon({
  size = 'w-[24px] h-[24px]',
  color = '#181D27',
}) {
  return (
    <svg
      className={size}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 4.5L16.5 12L9 19.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
